import { SchedulesSearchSlot, SlotStatus } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';

export interface ScheduleSlotsDay {
  date: string;
  slots: SchedulesSearchSlot[];
}

export function groupSlotsByDate(slots: SchedulesSearchSlot[]): ScheduleSlotsDay[] {
  const slotsByDate = slots.reduce(
    (acc, slot) => {
      if (slot.status !== SlotStatus.AVAILABLE) {
        return acc;
      }
      const date = slot.date.slice(0, 10);
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(slot);
      return acc;
    },
    {} as Record<string, SchedulesSearchSlot[]>,
  );

  return Object.keys(slotsByDate)
    .sort()
    .map((date) => ({
      date,
      slots: [...slotsByDate[date]].sort(
        (a, b) => a.start.localeCompare(b.start) || a.scheduleId.localeCompare(b.scheduleId),
      ),
    }));
}
